export default {
  data: () => ({
    selectedItems: [],
    tableHeaderMT: [
      {
        text: "Item",
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: "MT",
        align: "right",
        sortable: true,
        value: "mt"
      },
      {
        text: "RM",
        align: "right",
        sortable: true,
        value: "amt"
      }
    ],
    tableHeaderVisit: [
      {
        text: "Item",
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: "Visits",
        align: "right",
        sortable: true,
        value: "mt"
      },
      {
        text: "Strike Rate",
        align: "right",
        sortable: true,
        value: "amt"
      }
    ]
  })
};
